import {
    inAppMenu,
    manageYourTeam,
} from '@weirgroup/cde-iam-accessmanagement-app'
import { combineReducers } from 'redux'

const appReducer = combineReducers({
    manageYourTeam,
    inAppMenu,
})

const rootReducer = (state, action) => appReducer(state, action)

export default rootReducer
